"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingPageSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const clipboard_1 = require("@/app/shared/helpers/clipboard");
const outline_1 = require("@heroicons/react/24/outline");
const BookingPageSection = ({ title, bookingPages }) => {
    const copyLink = (link) => {
        (0, clipboard_1.copyToClipboard)(link);
    };
    const formatText = (text) => {
        if (!text)
            return '';
        return text
            .toLowerCase()
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    const formatTimeUnit = (unit) => {
        if (!unit)
            return '';
        return unit?.toLowerCase().charAt(0) || '';
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-2px pt-12px pb-10px', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-label-s-reg text-gray-60 px-12px pb-6px', children: title }), bookingPages.map((page) => ((0, jsx_runtime_1.jsxs)("div", { className: 'flex-left-center gap-8px border-radius-4px hover-bg-blue-4 hover-text-blue-dark cursor-pointer px-12px h-38px', onClick: () => page?.shortLink && copyLink(page.shortLink), children: [(0, jsx_runtime_1.jsxs)("div", { className: 'flex-1 flex flex-column gap-3px overflow-hidden', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-label-s-med text-gray-100 truncate', children: page.what?.customName }), (0, jsx_runtime_1.jsxs)("div", { className: 'text-label-xs-reg text-gray-60 truncate', children: [page.when?.duration?.count, formatTimeUnit(page.when?.duration?.timeUnit), ", ", formatText(page.where?.defaultLocationType)] })] }), (0, jsx_runtime_1.jsx)(outline_1.LinkIcon, { className: 'icon-14px' }), (0, jsx_runtime_1.jsx)("div", { className: 'text-label-s-reg', children: labels_1.default.SCHEDULER_COPY_LINK })] }, page.shortLink)))] }));
};
exports.BookingPageSection = BookingPageSection;
